export default Object.freeze({
  REDSHIFT: 'redshift',
  SNOWFLAKE: 'snowflake',
  S3: 's3',
  PINTEREST: 'pinterest',
  BIGQUERY: 'bigquery',
});
